<template>
    <div id="devAlarm">
        <p class="log-title">报警管理</p>
        <div class="list-box">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>报警记录</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>报警规则</span></div>
            </header>
            <div class="bg" style="height: 95%;">
                <!-- 报警记录 -->
                <div v-show="state == 0" style="height: 90%;">
                    <div class="search-box clearfix">
                        <div class="time-box f-l">
                            <span>时间：</span>
                            <el-date-picker
                                v-model="beginDate"
                                :editable="false"
                                type="date"
                                class="time m-r-12"
                                placeholder="选择日期"
                                :picker-options="pickerOptionsStart"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        <span>至</span>
                            <el-date-picker
                                v-model="endDate"
                                :editable="false"
                                type="date"
                                class="time"
                                placeholder="选择日期"
                                :picker-options="pickerOptionsEnd"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                        <div class="f-l">
                            <span>报警分类：</span>
                            <el-select v-model="ruleType" placeholder="请选择" class="state-box">
                                <el-option :value=null label="全部"></el-option>
                                <el-option :value=1 label="产品报警"></el-option>
                                <el-option :value=2 label="设备报警"></el-option>
                            </el-select>
                        </div>
                        <div class="f-l">
                            <span>状态：</span>
                            <el-select v-model="alarmState" placeholder="请选择" class="state-box">
                                <el-option :value=null label="全部"></el-option>
                                <el-option :value=1 label="已恢复"></el-option>
                                <el-option :value=2 label="存续"></el-option>
                                <el-option :value=3 label="手动恢复"></el-option>
                            </el-select>
                        </div>
                        <div class="f-r">
                            <el-button type="primary" class="add-btn m-r-10" @click="search">搜索</el-button>
                            <a :href="exportLogUrl" id="exportLog" class="exportLog-btn add-btn m-r-10" @click="exportLog" style="line-height: 34px !important;">导出</a>
                            <!-- <el-button type="primary" class="add-btn">一键确认</el-button> -->
                            <!-- <el-button type="primary" class="add-btn">一键恢复</el-button> -->
                        </div>
                        <!-- <div class="f-r m-r-12"></div> -->
                        <div class="f-r m-r-12 w-20">
                            <!-- <div class="f-r w-20 m-r-12">
                              
                            </div> -->
                            <div class="search">
                                <el-input
                                    placeholder="请输入名称"
                                    v-model="searchVal" class="search-input" @keyup.enter.native="search">
                                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix" style="height: 100%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-26">报警名称</li>
                            <li>报警时间</li>
                            <li class="w-90">报警分类</li>
                            <li class="w-90">确认人</li>
                            <li>确认时间</li>
                            <li class="w-90">当前状态</li>
                            <li>备注</li>
                            <li class="w-90">操作</li>
                        </ul>
                        <div class="scroll w-100 m-t-0" style="height: 85.5% !important; max-height: 85.5% !important;">
                            <ul class="list-details" v-for="(item,i) in warnListData" :key="i" v-show="warnListData.length!=0">
                                <li class="w-26" :title="item.name">{{item.name}}</li>
                                <li :title="changeTime(item.updatedTime)">{{changeTime(item.updatedTime)}}</li>
                                <li class="w-90" :title="item.ruleType==1?'产品报警':'设备报警'">{{item.ruleType==1?"产品报警":"设备报警"}}</li>
                                <li class="w-90" :title="item.operator==0?'未确认':item.operatorName">{{item.operator==0?'(未确认)':item.operatorName}}</li>
                                <li :title="changeTime(item.operateTime)">{{changeTime(item.operateTime)}}</li>
                                <li class="w-90" :title="item.state==1?'已恢复':item.state==2?'存续':'手动恢复'" :class="{'color-red':item.state==2}">{{item.state==1?'已恢复':item.state==2?'存续':'手动恢复'}}</li>
                                <li :title="item.note" v-show="item.resetOperator!=0&&item.resetOperator!=null">由{{item.resetOperatorName}}手动恢复<span v-show='item.note'>，{{item.note}}</span></li>
                                <li :title="item.note" v-show="item.resetOperator==0||item.resetOperator==null">{{item.note}}</li>
                                <li class="operate w-90">
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook}" @click="defineAlarm(item)" v-if="item.operator==0&&item.state==2">确认</span>
                                    <span class="disabled" v-if="item.operator!=0||item.state!=2">确认</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceContrl')||$store.state.isLook}" v-if="item.state==2" @click="open(i,'resetShow',item)">恢复</span>
                                    <span class="disabled" v-if="item.state!=2">恢复</span>
                                </li>
                            </ul>
                            <!-- 没有列表数据 -->
                            <div class="nullDataBox" v-show="warnListData.length==0">
                                <img :src="nullData" class="nullData">
                                <span>什么东西都没有找到...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 报警规则 -->
                <div v-show="state == 1" style="height: 95%;">
                    <header class="clearfix top-20">
                        <el-button type="primary" class="add-btn" @click="openAddAlarm" :disabled="!$store.state.functionList.includes('companyServiceEdit')">新建报警规则</el-button>
                    </header>
                    <div class="clearfix m-t-38" style="height: 95%;">
                        <ul class="list-title" style="width: 100%; margin-left: 0;">
                            <li class="w-26">报警名称</li>
                            <li class="w-90">规则类型</li>
                            <li class="w-90">报警级别</li>
                            <li>最近一次报警时间</li>
                            <li class="w-90">累计报警次数</li>
                            <li class="w-90">状态</li>
                            <li>操作</li>
                        </ul>
                        <div class="scroll" style="height: 95%; max-height: 95% !important;">
                            <ul class="list-details" v-for="(item,i) in WarnAlarmList" :key="i" v-show="WarnAlarmList.length!=0">
                                <li :title="item.ruleType==1&&item.deviceName?item.name+'/'+item.deviceName:item.name" class="w-26">{{item.name}}<span v-show='item.ruleType==1&&item.deviceName'>/{{item.deviceName}}</span></li>
                                <li class="w-90">{{item.ruleType==1?'通用报警':'自定义报警'}}</li>
                                <li class="w-90">{{item.level==1?'提示':item.level==2?'报警':'故障'}}</li>
                                <li :title="changeTime(item.updateTime)">{{changeTime(item.updateTime)}}</li>
                                <li class="w-90">{{item.number}}</li>
                                <li class="w-90" :class="{'color-red':item.state != 1}">{{item.state==1?'启用':'停用'}}</li>
                                <li class="operate">
                                    <span @click="editAlarm(item,i)" v-if="item.ruleType==2">{{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span v-if="item.ruleType==1" class="disable-span">{{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" @click="open(i,'delShow',item)" v-if="item.ruleType==2">删除</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" v-if="item.ruleType==1" class="disable-span">删除</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" v-show="item.state==1" @click="open(i,'disShow',item)">停用</span>
                                    <span :class="{'disabled':!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook}" v-show="item.state!=1" @click="open(i,'enableShow',item)">启用</span>
                                </li>
                            </ul>
                            <!-- 没有列表数据 -->
                            <div class="nullDataBox" v-show="WarnAlarmList.length==0">
                                <img :src="nullData" class="nullData">
                                <span>什么东西都没有找到...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页 -->
                <div style="margin-top: 32px;">
                    <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber" v-show="state==0"></Pagination>
                </div>
            </div>
            <!-- 弹窗 -->
            <div class="popup">
                <!-- 删除报警 -->
                <div class="popup-delAlarm" v-show="delShow">
                    <div class="popup-title">
                        删除报警<i class="el-icon-circle-close close" @click="close('delShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该报警规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="delAlarm" id="delAlarm">确定</el-button> <el-button @click="close('delShow')" id="closeDel2">取消</el-button></p>
                    </div>
                </div>
                <!-- 启用报警 -->
                <div class="popup-delAlarm" v-show="enableShow">
                    <div class="popup-title">
                        启用报警<i class="el-icon-circle-close close" @click="close('enableShow')" id="closeEnable1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将启用该报警规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="enableAlarm" id="enableAlarm">确定</el-button> <el-button @click="close('enableShow')" id="closeEnable2">取消</el-button></p>
                    </div>
                </div>
                <!-- 停用报警 -->
                <div class="popup-delAlarm" v-show="disShow">
                    <div class="popup-title">
                        停用报警<i class="el-icon-circle-close close" @click="close('disShow')" id="closeDis1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将停用该报警规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="disAlarm" id="disAlarm2">确定</el-button> <el-button @click="close('disShow')" id="closeDis2">取消</el-button></p>
                    </div>
                </div>
                <!-- 停用报警 -->
                <div class="popup-delAlarm" v-show="resetShow">
                    <div class="popup-title">
                        恢复报警<i class="el-icon-circle-close close" @click="close('resetShow')" id="resetAlarm1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将恢复该报警规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" @click="resetAlarm" id="resetAlarm2">确定</el-button> <el-button @click="close('resetShow')" id="resetAlarm3">取消</el-button></p>
                    </div>
                </div>
                <!-- 新建报警规则 -->
                <div class="popup-addAlarm" v-show="addAlarmShow">
                    <div class="popup-title">
                        新增规则<i class="el-icon-circle-close close" @click="close('addAlarmShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="addAlarm" class="clearfix">
                            <div class="alarm-left">
                                <el-form-item label="报警名称：" autocomplete="off" prop="alarmName">
                                    <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                    <el-input v-model="ruleForm.alarmName" placeholder="请输入您的规则名称"></el-input>
                                </el-form-item>
                                <el-form-item label="触发条件：" autocomplete="off" class="w-100 clearfix">
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.trigger">
                                            <p>触发条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.deviceCode`" :rules="rules.trigger_deviceCode">
                                                <el-select v-model="trigger.deviceCode" :title="trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,t,1)">
                                                    <el-option
                                                    :key="VirtualDevice.id"
                                                    label="虚拟设备"
                                                    :value="VirtualDevice.code" >
                                                    </el-option>
                                                    <el-option
                                                    v-for="devObj in deviceList"
                                                    :key="devObj.id"
                                                    :label="devObj.name"
                                                    :value="devObj.code" >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.property`" :rules="rules.trigger_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,t,'trigger')">
                                                    <el-option
                                                    v-for="attrObj in trigger.propertyData"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-95" :prop="`trigger.${t}.compare`" :rules="rules.trigger_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.value`" :rules="rules.trigger_value">
                                                <el-input class="attribute" placeholder="请输入比较值" :disabled="trigger.compare==10" @input="regNumber(t,'value','trigger')" v-model="trigger.value" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" :disabled="trigger.compare==10" class="attribute" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(1,t)" v-show="ruleForm.trigger.length!=1">删除</span>
                                            <span class="delAttr disabled2" v-show="ruleForm.trigger.length==1">删除</span>
                                        </div>
                                    </div>
                                    <p class="add-enum" @click="addtrigger(1)">+新增触发条件</p>
                                </el-form-item>
                                <el-form-item label="报警条件：" autocomplete="off">
                                    <el-form-item prop="duration">
                                        <div class="w-100 duration">
                                            <span>持续时间：</span><el-input @input="ruleForm.duration=ruleForm.duration.replace(/[^\d]/g, '');" v-model="ruleForm.duration" class="w-415"></el-input><span style="margin-left: 10px;">秒</span>
                                        </div>
                                    </el-form-item>
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.triggerWarn">
                                            <p>报警条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_deviceCode">
                                                <el-select v-model="trigger.deviceCode" :title="trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,t,2)">
                                                    <el-option
                                                    :key="VirtualDevice.id"
                                                    label="虚拟设备"
                                                    :value="VirtualDevice.code" >
                                                    </el-option>
                                                    <el-option
                                                    v-for="devObj in deviceList"
                                                    :key="devObj.id"
                                                    :label="devObj.name"
                                                    :value="devObj.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,t,'triggerWarn')">
                                                    <el-option
                                                    v-for="attrObj in trigger.propertyData"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-95" :prop="`triggerWarn.${t}.compare`" :rules="rules.triggerWarn_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.value`" :rules="rules.triggerWarn_value">
                                                <el-input class="attribute" placeholder="请输入比较值" :disabled="trigger.compare==10" @input="regNumber(t,'value','triggerWarn')" v-model="trigger.value" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" :disabled="trigger.compare==10" class="attribute" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(2,t)" v-show="ruleForm.triggerWarn.length!=1">删除</span>
                                            <span class="delAttr disabled2" v-show="ruleForm.triggerWarn.length==1">删除</span>
                                        </div>
                                    </div>
                                    <!--  @click="addtrigger(2)" -->
                                    <p class="add-enum" @click="addtrigger(2)">+新增报警条件</p>
                                </el-form-item>
                            </div>
                            <div class="alarm-right">
                                <p class="alarm-p">规则类型：自定义报警</p>
                                <el-form-item label="报警分类：" class="checkbox" prop="typeSet">
                                    <div class="checkbox-box">
                                        <el-checkbox-group v-model="ruleForm.typeSet">
                                            <el-checkbox v-for="type in warnData" :key="type.id" :label="type.id" name="warntype">{{type.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item>
                                <el-form-item label="报警级别：" autocomplete="off" class="m-b-0" prop="alarmLv">
                                    <el-radio-group v-model="ruleForm.alarmLv" class="nodeType">
                                        <el-radio :label=1>提示</el-radio>
                                        <el-radio :label=2>报警</el-radio>
                                        <el-radio :label=3>故障</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注：" class="m-t-20">
                                    <el-input
                                        type="textarea"
                                        class="remarks note"
                                        v-model="ruleForm.note"
                                        maxlength="255"
                                        show-word-limit
                                        id="editRemarks"
                                        placeholder="请输入描述">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="popup-btn-box"><el-button type="primary" @click="createdAlarm('addAlarm')">确定</el-button> <el-button @click="close('addAlarmShow')">取消</el-button></p>
                </div>
                <!-- 编辑报警规则 -->
                <div class="popup-addAlarm" v-show="editAlarmShow">
                    <div class="popup-title">
                        {{$store.state.functionList.includes('companyServiceEdit')&&!$store.state.isLook?'编辑':'查看'}}规则<i class="el-icon-circle-close close" @click="close('editAlarmShow')"></i>
                    </div>
                    <div class="poput-lab">
                        <el-form :model="ruleForm" :rules="rules" ref="editAlarm" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">
                            <div class="alarm-left">
                                <el-form-item label="报警名称：" autocomplete="off" prop="alarmName">
                                    <i><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                                    <el-input v-model="ruleForm.alarmName" placeholder="请输入您的规则名称"></el-input>
                                </el-form-item>
                                <el-form-item label="触发条件：" autocomplete="off" class="w-100 clearfix">
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.trigger">
                                            <p>触发条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.deviceCode`" :rules="rules.trigger_deviceCode">
                                                <el-select v-model="trigger.deviceCode" :title="trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,t,1)">
                                                    <el-option
                                                    :key="VirtualDevice.id"
                                                    label="虚拟设备"
                                                    :value="VirtualDevice.code" >
                                                    </el-option>
                                                    <el-option
                                                    v-for="devObj in deviceList"
                                                    :key="devObj.id"
                                                    :label="devObj.name"
                                                    :value="devObj.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.property`" :rules="rules.trigger_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,t,'trigger')">
                                                    <el-option
                                                    v-for="attrObj in trigger.propertyData"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-95" :prop="`trigger.${t}.compare`" :rules="rules.trigger_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`trigger.${t}.value`" :rules="rules.trigger_value">
                                                <el-input class="attribute" placeholder="请输入比较值" :disabled="trigger.compare==10" @input="regNumber(t,'value','trigger')" v-model="trigger.value" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" :disabled="trigger.compare==10" class="attribute" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(1,t)" v-show="ruleForm.trigger.length!=1">删除</span>
                                            <span class="delAttr disabled2" v-show="ruleForm.trigger.length==1">删除</span>
                                        </div>
                                    </div>
                                    <p class="add-enum" @click="addtrigger(1)">+新增触发条件</p>
                                </el-form-item>
                                <el-form-item label="报警条件：" autocomplete="off">
                                    <el-form-item prop="duration">
                                        <div class="w-100 duration">
                                            <span>持续时间：</span><el-input @input="ruleForm.duration=ruleForm.duration.replace(/[^\d]/g, '');" v-model="ruleForm.duration" class="w-415"></el-input><span style="margin-left: 10px;">秒</span>
                                        </div>
                                    </el-form-item>
                                    <div class="trigger-box">
                                        <div class="condition-box clearfix" v-for="(trigger,t) in ruleForm.triggerWarn">
                                            <p>报警条件{{t+1}}</p>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_deviceCode">
                                                <el-select v-model="trigger.deviceCode" :title="trigger.deviceCode==VirtualDevice.code?'虚拟设备':getTitle(trigger.deviceCode,deviceList,'code')" placeholder="请选择设备" class="attribute" @change="changeDev($event,t,2)">
                                                    <el-option
                                                    :key="VirtualDevice.id"
                                                    label="虚拟设备"
                                                    :value="VirtualDevice.code" >
                                                    </el-option>
                                                    <el-option
                                                    v-for="devObj in deviceList"
                                                    :key="devObj.id"
                                                    :label="devObj.name"
                                                    :value="devObj.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.property`" :rules="rules.triggerWarn_property">
                                                <el-select v-model="trigger.property" :title="getTitle(trigger.property,trigger.propertyData,'identifier')" placeholder="请选择属性" class="attribute" @change="changeAttr($event,t,'triggerWarn')">
                                                    <el-option
                                                    v-for="attrObj in trigger.propertyData"
                                                    :key="attrObj.identifier"
                                                    :label="attrObj.name"
                                                    :value="attrObj.identifier" v-if="attrObj.dataType.type!='text'&&attrObj.dataType.type!='date'">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-95" :prop="`triggerWarn.${t}.compare`" :rules="rules.triggerWarn_compare">
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'">
                                                    <el-option :value=1 label=">"></el-option>
                                                    <el-option :value=2 label=">="></el-option>
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=4 label="<"></el-option>
                                                    <el-option :value=5 label="<="></el-option>
                                                    <el-option :value=6 label="!="></el-option>
                                                    <el-option :value=7 label="in"></el-option>
                                                    <el-option :value=8 label="between"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                                <el-select v-model="trigger.compare" placeholder="请选择" class="attribute w-75" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option :value=3 label="=="></el-option>
                                                    <el-option :value=9 label="pulse" v-show="trigger.type == 'bool'"></el-option>
                                                    <el-option :value=10 label="unchange"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" autocomplete="off" class="w-28" :prop="`triggerWarn.${t}.value`" :rules="rules.triggerWarn_value">
                                                <el-input class="attribute" placeholder="请输入比较值" :disabled="trigger.compare==10" @input="regNumber(t,'value','triggerWarn')" v-model="trigger.value" v-show="trigger.type == 'int' || trigger.type == 'float' || trigger.type == 'double'"></el-input>
                                                <el-select v-model="trigger.value" placeholder="请选择" :disabled="trigger.compare==10" class="attribute" v-show="trigger.type == 'bool' || trigger.type == 'enum'">
                                                    <el-option
                                                    v-for="specsObj in trigger.propertyData.specs"
                                                    :key="specsObj.key"
                                                    :label="specsObj.value"
                                                    :value="specsObj.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <span class="delAttr" @click="deltrigger(2,t)" v-show="ruleForm.triggerWarn.length!=1">删除</span>
                                            <span class="delAttr disabled2" v-show="ruleForm.triggerWarn.length==1">删除</span>
                                        </div>
                                    </div>
                                    <!--  @click="addtrigger(2)" -->
                                    <p class="add-enum" @click="addtrigger(2)">+新增报警条件</p>
                                </el-form-item>
                            </div>
                            <div class="alarm-right">
                                <p class="alarm-p">规则类型：自定义报警</p>
                                <el-form-item label="报警分类：" class="checkbox" prop="typeSet">
                                    <div class="checkbox-box">
                                        <el-checkbox-group v-model="ruleForm.typeSet">
                                            <el-checkbox v-for="type in warnData" :key="type.id" :label="type.id" name="warntype">{{type.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </el-form-item>
                                <el-form-item label="报警级别：" autocomplete="off" class="m-b-0" prop="alarmLv">
                                    <el-radio-group v-model="ruleForm.alarmLv" class="nodeType">
                                        <el-radio :label=1>提示</el-radio>
                                        <el-radio :label=2>报警</el-radio>
                                        <el-radio :label=3>故障</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="备注：" class="m-t-20">
                                    <el-input
                                        type="textarea"
                                        class="remarks note"
                                        v-model="ruleForm.note"
                                        maxlength="255"
                                        show-word-limit
                                        id="editRemarks2"
                                        placeholder="请输入描述">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="popup-btn-box"><el-button type="primary" @click="updateAlarm('editAlarm')" :disabled="!$store.state.functionList.includes('companyServiceEdit')||$store.state.isLook">确定</el-button> <el-button @click="close('editAlarmShow')">取消</el-button></p>
                </div>
                <!-- 验证码授权 -->
                <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px">
                    <div class="popup-title">
                        获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                    </div>
                    <div class="popup-lab">
                        手机号：
                        <el-input disabled v-model="phone">{{phone}}</el-input>
                    </div>
                    <div class="popup-lab clearfix">
                        <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                        <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                            <el-form-item prop="verifyCode">
                                <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                    <div class="popup-lab">
                        <p class="btn-box" style="margin-top: 28px; text-align: center;">
                            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        var valiWarnName = (rule, value, callback) =>{  //规则名称
            value=this.ruleForm.alarmName;
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入规则名称'));
            }else if(value.length>32){
                callback(new Error('规则名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valitrigger = (rule, value, callback) =>{   //验证触发条件
            let i = 0
            let isTrue = true;
            for( let regObj of this.ruleForm.trigger){
                i++
                if(regObj.property == null){
                    callback(new Error(`请选择触发条件${i}的属性`));
                    isTrue = false;
                }else if(regObj.compare == null){
                    callback(new Error(`请选择触发条件${i}的比较模式`));
                    isTrue = false;
                }else if(regObj.value == null || regObj.value == ""){
                    callback(new Error(`触发条件${i}的比较值不能为空`));
                    isTrue = false;
                }else if(regObj.compare == 8){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" || str.indexOf(",") == -1 ||str.indexOf(",") == str.length-1){
                        callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        if(arr.length!=2){
                            callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                            isTrue = false;
                        }else if(Number(arr[0])>Number(arr[1]) || Number(arr[0])<regObj.propertyData.specs.min || Number(arr[1])>regObj.propertyData.specs.max){
                            callback(new Error(`触发条件${i}的比较值错误,第一个值需小于第二个值，且不能超出属性定义范围`));
                            isTrue = false;
                        }
                    }
                }else if(regObj.compare == 7){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" ||str.indexOf(",") == str.length-1){
                        callback(new Error(`触发条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        for(let index in arr){
                            if(Number(arr[index])>Number(regObj.propertyData.specs.max) || Number(arr[index])<Number(regObj.propertyData.specs.min)){
                                callback(new Error(`触发条件${i}的比较值错误,第${Number(index)+1}个值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }else if(regObj.type != "bool" ||regObj.type != "enum" && regObj.compare == 7 ||regObj.compare == 8){
                    for(let obj of regObj.propertyData){
                        if(regObj.property==obj.identifier){
                            if(Number(regObj.value)>Number(obj.dataType.specs.max) || Number(regObj.value)<Number(obj.dataType.specs.min)){
                                callback(new Error(`报警条件${i}的比较值错误,值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }
            }
            if(isTrue){
                callback()
            }
        }
        var validuration= (rule, value, callback) =>{   //验证报警条件
            if(Number(this.ruleForm.duration)>2592000||Number(this.ruleForm.duration)<0){
                callback(new Error('持续时间超出范围，范围：0~2592000'));
            }else if(this.ruleForm.duration!=0&&(this.ruleForm.duration ==''||this.ruleForm.duration ==null)){
                callback(new Error('请输入持续时间'))
            }else{
                callback()
            }
        }
        var valitriggerWarn = (rule, value, callback) =>{   //验证报警条件
            let i = 0
            let isTrue = true;
            for( let regObj of this.ruleForm.triggerWarn){
                i++;
                if(this.ruleForm.triggerWarn.length==1&&(regObj.property == null||regObj.property=="")&&(regObj.value == null||regObj.value=="")){
                    callback()
                }
                if(regObj.property == null){
                    callback(new Error(`请选择报警条件${i}的属性`));
                    isTrue = false;
                }else if(regObj.compare == null){
                    callback(new Error(`请选择报警条件${i}的比较模式`));
                    isTrue = false;
                }else if(regObj.value == null || regObj.value == ""){
                    callback(new Error(`报警条件${i}的比较值不能为空`));
                    isTrue = false;
                }else if(regObj.compare == 8){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" || str.indexOf(",") == -1 ||str.indexOf(",") == str.length-1){
                        callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        if(arr.length!=2){
                            callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                            isTrue = false;
                        }else if(Number(arr[0])>Number(arr[1]) || Number(arr[0])<regObj.propertyData.specs.min || Number(arr[1])>regObj.propertyData.specs.max){
                            callback(new Error(`报警条件${i}的比较值错误,第一个值需小于第二个值，且不能超出属性定义范围`));
                            isTrue = false;
                        }
                    }
                }else if(regObj.compare == 7){
                    let str = regObj.value
                    str = str.substr(0,str.length-1).substr(1,str.length-1)
                    if(str=="" ||str.indexOf(",") == str.length-1){
                        callback(new Error(`报警条件${i}的比较值格式错误,格式:[1,2]`));
                        isTrue = false;
                    }else{
                        let arr = str.split(",")
                        for(let index in arr){
                            if(Number(arr[index])>Number(regObj.propertyData.specs.max) || Number(arr[index])<Number(regObj.propertyData.specs.min)){
                                callback(new Error(`报警条件${i}的比较值错误,第${Number(index)+1}个值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }else if(regObj.type != "bool" ||regObj.type != "enum" && regObj.compare == 7 ||regObj.compare == 8){
                    for(let obj of regObj.propertyData){
                        if(regObj.property==obj.identifier){
                            if(Number(regObj.value)>Number(obj.dataType.specs.max) || Number(regObj.value)<Number(obj.dataType.specs.min)){
                                callback(new Error(`报警条件${i}的比较值错误,值超出属性定义范围`));
                                isTrue = false;
                            }
                        }
                    }
                }
            }
            if(isTrue){
                callback()
            }
        }
        var valiWarnProperty=  (rule, value, callback) =>{
            let obj = this.ruleForm.triggerWarn[rule.field.charAt(12)]
            if(obj.deviceCode==null||obj.deviceCode==''){
                callback()
            }else{
                if(obj.property==''||obj.property==null){
                    callback(new Error('请选择属性'))
                }else{
                    callback()
                }
            }
        }
        var valiWarnCompare=  (rule, value, callback) =>{
            let obj = this.ruleForm.triggerWarn[rule.field.charAt(12)]
            if(obj.deviceCode==null||obj.deviceCode==''){
                callback()
            }else{
                if(obj.compare==''||obj.compare==null){
                    callback(new Error('请选择比较模式'))
                }else{
                    callback()
                }
            }
        }
        var valiWarnValue=  (rule, value, callback) =>{
            let obj = this.ruleForm.triggerWarn[rule.field.charAt(12)]
            if(obj.deviceCode==null||obj.deviceCode==''){
                callback()
            }else{
                if((obj.value==''||obj.value==null)&&obj.compare!=10){
                    callback(new Error('比较值不能为空'))
                }else{
                    callback()
                }
            }
        }
        var valiTriggerValue=  (rule, value, callback) =>{
            let obj = this.ruleForm.trigger[rule.field.charAt(8)]
            if((obj.value==''||obj.value==null)&&obj.compare!=10){
                callback(new Error('比较值不能为空'))
            }else{
                callback()
            }
        }

        return {
            state:0,
            totalCount:0,
            pageSize:0,
            pageNumber:1,
            delShow:false,
            disShow:false,
            enableShow:false,
            addAlarmShow:false,
            editAlarmShow:false,
            resetShow:false,
            radio:0,            //周期时间
            beginDate:null,     //开始时间
            endDate:null,       //结束时间
            alarmState:null,    //状态
            ruleType:null,
            searchVal:'',
            notes:require('@/assets/image/organize/notes.png'),
            nullData:require('@/assets/image/index/nullData.png'),
            warnListData:[],    //报警记录列表
            WarnAlarmList:[],   //报警规则列表
            warnData:[],
            deviceList:[],
            VirtualDevice:{},   //虚拟设备
            VirtualFuncList:[], //虚拟设备属性列表
            exportLogUrl:'',
            // allProductData:[],
            ruleForm:{
                id:null,
                alarmName:'',
                deviceCode:null,      //所属设备编号
                trigger:[           //触发条件
                    {
                        deviceCode:null,  //设备
                        property:null,  //属性
                        compare:null,   //比较模式
                        value:null,     //值
                        type:'int',     //类型
                        propertyData:[
                            {dataType:{type:'int'},specs:[]}
                        ]
                    }
                ],
                triggerWarn:[           //报警条件
                    {
                        deviceCode:null,
                        property:null,
                        compare:null,
                        value:null,
                        type:'int',
                        propertyData:[
                            {dataType:{type:'int'},specs:[]}
                        ]
                    }
                ],
                duration:0,
                typeSet:[],         //报警类型编号集
                typeNameSet:"",     //报警类型名称集
                note:"",
                alarmLv:1,
                nowAlarm:{},
                nowAlarmIndex:0
            },
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                alarmName:[{validator: valiWarnName, required: true, trigger: 'blur'}],
                trigger:[{validator: valitrigger, required: true, trigger: 'change'}],
                triggerWarn:[{validator: valitriggerWarn, required: false, trigger: 'submit'}],
                typeSet:[{required: false, message:"请选择报警分类", trigger: 'blur'}],
                alarmLv:[{required: true, message:"请选择报警级别", trigger: 'blur'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
                duration:[{required: false, validator: validuration, trigger: 'blur'}],
                trigger_deviceCode:[{required: true, message:"请选择设备", trigger: 'change'}],
                trigger_property:[{required: true, message:"请选择属性", trigger: 'change'}],
                trigger_compare:[{required: true, message:"请选择比较模式", trigger: 'change'}],
                trigger_value:[{required: false, validator:valiTriggerValue, trigger: 'change'}],
                triggerWarn_deviceCode:[{required: false, trigger: 'change'}],
                triggerWarn_property:[{required: false, validator: valiWarnProperty, trigger: 'change'}],
                triggerWarn_compare:[{required: false, validator: valiWarnCompare, trigger: 'change'}],
                triggerWarn_value:[{required: false, validator: valiWarnValue, trigger: 'change'}],
            },
            nowObj:{},
            nowIndex:null,
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
            functionShow:false,
            VerifyArr:[],
            verifyCode:'',
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
            client:false,
            mqttTrue:true,
            VerifyVal:null,
        }
    },
    components:{
        Pagination
    },
    props: {
        companyId:{
            type:Number,
            required:true,
        }
    },
    created() {
        this.$store.state.headerActive=2;
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getAlarmList({pageNumber:1,length:this.pageSize,state:null,confirmState:null,companyId:this.companyId})
        this.getAlarmRuleList({companyId:this.companyId});
        this.getwarnData()
        this.getdeviceList()
        // this.getProlist()
        this.getVirtualDevice()
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        console.log(this.$store.state.functionList)
    },
    updated() {
      if(!this.client){
        this.client = this.$store.state.client
      }
    },
    methods: {
        // 获取报警记录
        getAlarmList(parm){
            this.get('/DeviceAlarm/query',parm).then((res)=>{
                if(res.success){
                    this.warnListData = res.result.data
                    this.totalCount = res.result.totalCount
                }
            })
        },
        //获取报警规则列表
        getAlarmRuleList(parm){
            this.get('/AlarmRule/getList',parm).then((res)=>{
                if(res.success){
                    this.WarnAlarmList = res.result
                }
            })
        },
        //获取报警分类
        getwarnData(){
            this.get('/Dict/getListByType',{type:2}).then((res)=>{
                this.warnData=res.result
            })
        },
        //获取设备列表
        getdeviceList(){
            let parm = {companyId:this.companyId}
            this.get('/Device/getList',parm).then((res)=>{
                if(res.success){
                    this.deviceList = res.result
                }
            })
        },
        //获取指定企业的虚拟设备
        getVirtualDevice(){
            let parm = {companyId:this.companyId}
            this.get('/VirtualDevice/get',parm).then((res)=>{
                if(res.success){
                    this.VirtualDevice = res.result
					this.getVirtualFuncList()
                }
            }).then(()=>{
                this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
            })
        },
        //获取虚拟设备的属性列表
        getVirtualFuncList(){
			if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
            let parm = {deviceId:this.VirtualDevice.id,companyId:this.companyId}
            this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                if(res.success){
                    for(let obj of res.result){
                        obj.dataType={type:'double',specs:[]}
                        obj.identifier = obj.code
                    }
                    this.VirtualFuncList = res.result
                }
            })
        },
        // 验证数字输入框
        regNumber(i,regObj,name){
            if(this.ruleForm[name][i].compare==7||this.ruleForm[name][i].compare==8){
                this.ruleForm[name][i][regObj] = '['+this.ruleForm[name][i][regObj].replace(/[^\-?\d.,]/g,"").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",")+']';
            }else{
                this.ruleForm[name][i][regObj] = this.ruleForm[name][i][regObj].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
            }
        },
        // 头部点击
        headClick(i){
            this.state = i
            if(i==0){
                this.getAlarmList({pageNumber:1,length:this.pageSize,state:this.alarmState,confirmState:null,ruleType:this.ruleType,companyId:this.companyId})
            }else{
                this.getAlarmRuleList({companyId:this.companyId});
            }
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm = {
                companyId:this.companyId,
                pageNumber:this.pageNumber,
                length:this.pageSize,
                state:this.alarmState,
                ruleType:this.ruleType,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.searchVal
            }
            this.getAlarmList(parm)
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            let parm = {
                companyId:this.companyId,
                pageNumber:this.pageNumber,
                length:this.pageSize,
                state:this.alarmState,
                ruleType:this.ruleType,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.searchVal
            }
            this.getAlarmList(parm)
        },
        //设备变更时更新对应属性值
        changeDev(code,i,key){
            let arr=[]
            if(code==this.VirtualDevice.code){
                arr = this.VirtualFuncList
            }else{
                this.get('/ProductFeature/getByDeviceCode',{code:code}).then((res)=>{
                    if(res.success){
                        let propertyArr  //设备关联属性数组
                        for(let devObj of this.deviceList){
                            if(devObj.code == code){
                                propertyArr = devObj.propertySet.split(',')
                            }
                        }
                        let proData = JSON.parse(res.result).properties     //产品tsl
                        for(let proObj of proData){
                            for(let property of propertyArr){
                                if(property==proObj.identifier){
                                    arr.push(proObj)
                                }
                            }
                        }
                    }else{
                        this.$message({
                            message:`获取属性失败：${res.message}`,
                            type:'warning'
                        })
                    }
                })

            }
            if(key==1){
                this.ruleForm.trigger[i].propertyData = arr
                this.ruleForm.trigger[i].property =null
                this.ruleForm.trigger[i].compare = null
                this.ruleForm.trigger[i].value =null
            }else{
                this.ruleForm.triggerWarn[i].propertyData = arr
                this.ruleForm.triggerWarn[i].property =null
                this.ruleForm.triggerWarn[i].compare = null
                this.ruleForm.triggerWarn[i].value =null
            }
        },
        //设备属性变更时改变对应比较值
        changeAttr(val,i,name){
            this.ruleForm[name][i].compare=null;
            this.ruleForm[name][i].value=null;
            for(var obj of this.ruleForm[name][i].propertyData){
                if(val == obj.identifier){
                    this.ruleForm[name][i].type=obj.dataType.type
                    if(obj.dataType.type=="bool"||obj.dataType.type=="enum"){
                        let arr = [];
                        var that = this;
                        Object.keys(obj.dataType.specs).forEach(function(key){
                            let item ={};
                            item.key = key;
                            item.value = obj.dataType.specs[key]
                            arr.push(item);
                        });
                        that.ruleForm[name][i].propertyData.specs=arr;
                    }
                }
            }
        },
        // 打开弹窗
        open(i,name,obj){
            // if(name=='editAlarmShow'){
            //     let parm = {
            //         id:obj.id,
            //         companyId:this.companyId,
            //         requestId:1
            //     }
            //     this.get('/DeviceAlarmRule/get',parm).then((res)=>{
            //         if(res.success){
            //             let obj = re.result
            //             obj.andConditions = JSON.parse(obj.andConditions),
            //             obj.orConditions = JSON.parse(obj.orConditions),
            //             console.log(obj)
            //         }else{
            //             this.$message({
            //                 message: `获取规则详情失败:${res.message}`,
            //                 type: 'warning'
            //             });
            //         }
            //     })
            // }
            if(name!="resetShow"&&(!this.$store.state.functionList.includes('companyServiceEdit')||this.$store.state.isLook)||name=="resetShow"&&(!this.$store.state.functionList.includes('companyServiceContrl')||this.$store.state.isLook)){
                return
            }
            if(name=="resetShow"&&this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceContrl')){
                this.VerifyVal = 12
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this[name]=true;
            this.$store.state.mask=true;
            this.nowIndex=i;
            this.nowObj=obj;
        },
        // 关闭弹窗
        close(name){
            this.$store.state.mask=false;
            this[name]=false;
            this.ruleForm = this.$options.data().ruleForm;
            this.verifyForm.verifyCode = ''
        },
        //删除条件
        deltrigger(i,index){
            if(i==1){
                this.ruleForm.trigger.splice(index,1)
                if(this.addAlarmShow){
                    this.$refs.addAlarm.validateField("trigger")
                }else{
                    this.$refs.editAlarm.validateField("trigger")
                }
            }else{
                this.ruleForm.triggerWarn.splice(index,1)
            }
        },
        //添加条件
        addtrigger(i){
            let obj={
                deviceCode:null,
                property:null,
                compare:null,
                value:null,
                type:'int',
                propertyData:[
                    {dataType:{type:'int'}}
                ]
            }
            if(i==1){
                if(this.ruleForm.trigger.length==5){
                    this.$message({
                        message: '添加失败，触发条件最多5条',
                        type: 'warning'
                    });
                }else{
                    this.ruleForm.trigger.push(obj)
                }
            }else{
                if(this.ruleForm.triggerWarn.length==5){
                    this.$message({
                        message: '添加失败，报警条件最多5条',
                        type: 'warning'
                    });
                }else{
                    this.ruleForm.triggerWarn.push(obj)
                }
            }
        },
        search(){
            let parm = {
                companyId:this.companyId,
                pageNumber:this.pageNumber,
                length:this.pageSize,
                state:this.alarmState,
                ruleType:this.ruleType,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.searchVal
            }
            this.getAlarmList(parm)
        },
        //创建报警规则
        createdAlarm(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let typeData="",typeNameData="";
                    for(let id of this.ruleForm.typeSet){ //报警分类
                        for(let obj of this.warnData){
                            if(id==obj.id){
                                typeData += id+","
                                typeNameData += obj.name+","
                            }
                        }
                    }
                    typeData = typeData.substr(0,typeData.length - 1);
                    typeNameData = typeNameData.substr(0,typeNameData.length - 1);
                    let parm={
                        id:null,
                        companyId:this.companyId,
                        name:this.ruleForm.alarmName,
                        typeSet:typeData,
                        typeNameSet:typeNameData,
                        level:this.ruleForm.alarmLv,
                        orCondition:[],
                        andCondition:[],
                        duration:this.ruleForm.duration,
                        note:this.ruleForm.note,
                    }
                    for(let orCondi of this.ruleForm.trigger){
                        let obj = {};
                        obj.deviceCode = orCondi.deviceCode
                        obj.property = orCondi.property;
                        obj.compare = orCondi.compare;
                        obj.value = orCondi.value;
                        parm.orCondition.push(obj);
                    }
                    for(let andCondi of this.ruleForm.triggerWarn){
                        let obj = {};
                        obj.deviceCode = andCondi.deviceCode
                        obj.property = andCondi.property;
                        obj.compare = andCondi.compare;
                        obj.value = andCondi.value;
                        if(obj.deviceCode&&obj.property&&obj.compare&&obj.value){
                            parm.andCondition.push(obj);
                        }
                    }
                    if(parm.andCondition.length==0){
                        parm.andCondition=null
                    }
                    this.postNoJson('/DeviceAlarmRule/create',parm).then((res)=>{
                        if(res.success){
                            parm.id=res.result;
                            this.$message({
                                message: '新建报警规则成功',
                                type: 'success'
                            });
                            this.get('/AlarmRule/get',{ruleId:parm.id,companyId:this.companyId}).then((res=>{
                                if(res.success){
                                    this.WarnAlarmList.push(res.result)
                                }
                            }))
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                message: `新建报警规则失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.addAlarmShow = false;
                        this.$store.state.mask=false;
                    })
                }
            })
        },
        // 编辑规则
        updateAlarm(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let typeData="",typeNameData="";
                    for(let id of this.ruleForm.typeSet){ //报警分类
                        for(let obj of this.warnData){
                            if(id==obj.id){
                                typeData += id+","
                                typeNameData += obj.name+","
                            }
                        }
                    }
                    typeData = typeData.substr(0,typeData.length - 1);
                    typeNameData = typeNameData.substr(0,typeNameData.length - 1);
                    let parm={
                        id:this.ruleForm.id,
                        companyId:this.companyId,
                        name:this.ruleForm.alarmName,
                        typeSet:typeData,
                        typeNameSet:typeNameData,
                        level:this.ruleForm.alarmLv,
                        orCondition:[],
                        andCondition:[],
                        duration:this.ruleForm.duration,
                        note:this.ruleForm.note,
                    }
                    for(let orCondi of this.ruleForm.trigger){
                        let obj = {};
                        obj.deviceCode = orCondi.deviceCode
                        obj.property = orCondi.property;
                        obj.compare = orCondi.compare;
                        obj.value = orCondi.value;
                        parm.orCondition.push(obj);
                    }
                    for(let andCondi of this.ruleForm.triggerWarn){
                        let obj = {};
                        obj.deviceCode = andCondi.deviceCode
                        obj.property = andCondi.property;
                        obj.compare = andCondi.compare;
                        obj.value = andCondi.value;
                        if(obj.deviceCode&&obj.property&&obj.compare&&obj.value){
                            parm.andCondition.push(obj);
                        }
                    }
                    if(parm.andCondition.length==0){
                        parm.andCondition=null
                    }
                    this.postNoJson('/DeviceAlarmRule/update',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '编辑报警规则成功',
                                type: 'success'
                            });
                            this.getAlarmRuleList({companyId:this.companyId})
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                message: `编辑报警规则失败：${res.message}`,
                                type: 'warning'
                            });
                        }
                        this.editAlarmShow = false;
                        this.$store.state.mask=false;
                    })
                }
            })
        },
        //确认报警
        defineAlarm(item){
            if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceContrl')){
                this.VerifyVal = 12
                this.functionShow=true;
                this.$store.state.mask = true
                return
            } //判断权限
            if(item.operator!=0 ||!this.$store.state.functionList.includes('companyServiceContrl')||this.$store.state.isLook){
                return
            } //判断短信授权
            this.get('/DeviceAlarm/confirm',{id:item.id,companyId:this.companyId}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '确认报警成功',
                        type: 'success'
                    });
                    item.operator=this.$store.state.userData.id,
                    item.operatorName=this.$store.state.userData.displayName
                    item.operateTime = new Date().getTime()
                }else{
                    this.$message({
                        message: `确认报警失败:${res.message}`,
                        type: 'warning'

                    });
                }
            })
        },
        // 恢复报警
        resetAlarm(item){
            this.get('/DeviceAlarm/handrestore',{id:this.nowObj.id,companyId:this.companyId}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '恢复报警成功',
                        type: 'success'
                    });
                    this.search()
                    this.$store.state.mask = false;
                    this.resetShow = false;
                }else{
                    this.$message({
                        message: `恢复报警失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //删除报警规则
        delAlarm(){
            this.get('/DeviceAlarmRule/remove',{id:this.nowObj.ruleId}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除报警规则成功',
                        type: 'success'
                    });
                    this.getAlarmRuleList({companyId:this.companyId});
                }else{
                    this.$message({
                        message: `删除报警规则失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.delShow=false;
            })
        },
        //启用报警规则
        enableAlarm(){
            this.get('/AlarmRule/enable',{id:this.nowObj.ruleId,companyId:this.companyId,ruleType:this.nowObj.ruleType}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '启用报警规则成功',
                        type: 'success'
                    });
                    this.WarnAlarmList[this.nowIndex].state = 1
                }else{
                    this.$message({
                        message: `启用报警规则失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.enableShow=false;
            })
        },
        //停用报警规则
        disAlarm(){
            this.get('/AlarmRule/disable',{id:this.nowObj.ruleId,companyId:this.companyId,ruleType:this.nowObj.ruleType}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '停用报警规则成功',
                        type: 'success'
                    });
                    this.WarnAlarmList[this.nowIndex].state = 2
                }else{
                    this.$message({
                        message: `停用报警规则失败：${res.message}`,
                        type: 'warning'
                    });
                }
                this.$store.state.mask=false;
                this.disShow=false;
            })
        },
        //打开编辑规则弹窗
        editAlarm(item,i){
            if(this.VerifyArr.includes(14)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceEdit')){
                this.VerifyVal = 14
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.nowAlarm = this.clone(item);
            let ruleObj={};
            this.get('/DeviceAlarmRule/get',{companyId:this.companyId,id:item.ruleId}).then((res)=>{
                if(res.success){
                    ruleObj = res.result;
                    this.nowAlarmIndex = i;
                    this.ruleForm.id = item.ruleId;
                    this.ruleForm.alarmName = ruleObj.name;
                    this.ruleForm.alarmLv = ruleObj.level;
                    this.ruleForm.note = ruleObj.note;
                    this.ruleForm.duration = ruleObj.duration;
                    this.ruleForm.typeSet = ruleObj.typeSet.split(',').map(Number);
                    this.ruleForm.trigger = []
                    this.ruleForm.triggerWarn = []
                    ruleObj.orConditions = JSON.parse(ruleObj.orConditions);
                    ruleObj.andConditions = ruleObj.andConditions ==""?null:JSON.parse(ruleObj.andConditions);
                    if(ruleObj.orConditions){
                        for(let trigger of ruleObj.orConditions){       //触发条件
                            if(trigger.deviceCode == this.VirtualDevice.code){
                                trigger.propertyData=this.VirtualFuncList
                                trigger.type = 'double'
                                this.ruleForm.trigger.push(trigger)
                            }else{
                                this.get('/ProductFeature/getByDeviceCode',{code:trigger.deviceCode}).then((res)=>{
                                    if(res.success){
                                        let proFunction=JSON.parse(res.result)
                                        //属性数组
                                        let attrData = proFunction.properties
                                        let propertyArr  //设备关联属性数组
                                        for(let devObj of this.deviceList){
                                            if(devObj.code == trigger.deviceCode){
                                                propertyArr = devObj.propertySet.split(',')
                                            }
                                        }
                                        let arr = []
                                        for(let attrObj of attrData){
                                            for(let property of propertyArr){
                                                if(property==attrObj.identifier){
                                                    arr.push(attrObj)
                                                }
                                            }
                                        }
                                        trigger.propertyData = arr;
                                        for(let typeObj of arr){
                                            if(trigger.property == typeObj.identifier){
                                                trigger.type = typeObj.dataType.type
                                                if(trigger.type == "bool"||trigger.type=="enum"){
                                                    trigger.propertyData.specs = []
                                                    let arr = [];
                                                    Object.keys(typeObj.dataType.specs).forEach(function(key){
                                                        let obj ={};
                                                        obj.key = key;
                                                        obj.value = typeObj.dataType.specs[key];
                                                        arr.push(obj);
                                                    });
                                                    trigger.propertyData.specs=arr;
                                                }
                                                this.ruleForm.trigger.push(trigger)
                                            }
                                        }
                                    }
                                })
                            }
                            trigger.value=String(trigger.value);
                        }
                    }else{
                        this.ruleForm.trigger=[{deviceCode:null,property:null,compare:1,value:null,type:'int',propertyData:[{dataType:{type:'int'}}]}]
                    }
                    if(ruleObj.andConditions){
                        for(let trigger of ruleObj.andConditions){       //报警条件\
                            trigger.value=String(trigger.value);
                            if(trigger.deviceCode == this.VirtualDevice.code){
                                trigger.propertyData=this.VirtualFuncList
                                trigger.type = 'double'
                                this.ruleForm.triggerWarn.push(trigger)
                            }else{
                                this.get('/ProductFeature/getByDeviceCode',{code:trigger.deviceCode}).then((res)=>{
                                    if(res.success){
                                        let proFunction=JSON.parse(res.result)
                                        //属性数组
                                        let attrData = proFunction.properties
                                        let propertyArr  //设备关联属性数组
                                        for(let devObj of this.deviceList){
                                            if(devObj.code == trigger.deviceCode){
                                                propertyArr = devObj.propertySet.split(',')
                                            }
                                        }
                                        let arr = []
                                        for(let attrObj of attrData){
                                            for(let property of propertyArr){
                                                if(property==attrObj.identifier){
                                                    arr.push(attrObj)
                                                }
                                            }
                                        }
                                        trigger.propertyData = arr;
                                        for(let typeObj of arr){
                                            if(trigger.property == typeObj.identifier){
                                                trigger.type = typeObj.dataType.type
                                                if(trigger.type == "bool"||trigger.type=="enum"){
                                                    trigger.propertyData.specs = []
                                                    let arr = [];
                                                    Object.keys(typeObj.dataType.specs).forEach(function(key){
                                                        let obj ={};
                                                        obj.key = key;
                                                        obj.value = typeObj.dataType.specs[key];
                                                        arr.push(obj);
                                                    });
                                                    trigger.propertyData.specs=arr;
                                                }
                                                this.ruleForm.triggerWarn.push(trigger)
                                            }
                                        }
                                    }
                                })
                            }
                        }
                    }else{
                        this.ruleForm.triggerWarn=[{deviceCode:null,property:null,compare:1,value:null,type:'int',propertyData:[{dataType:{type:'int'}}]}]
                    }
                    this.$store.state.mask=true;
                    this.editAlarmShow=true;
                    this.$forceUpdate()
                    this.$refs.editAlarm.clearValidate()
                }else{
                    this.$message({
                        message: `获取规则详情失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 打开新增页面
        openAddAlarm(){
            if(this.VerifyArr.includes(14)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceEdit')){
                this.VerifyVal = 14
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.$refs.addAlarm.clearValidate()
            this.ruleForm=this.$options.data().ruleForm
            this.$store.state.mask=true;
            this.addAlarmShow =true;
        },
        // 导出报警记录
        exportLog(){
            let beginDate=this.beginDate==''||this.beginDate==null?'':new Date(this.beginDate+' 00:00:00').getTime().toString()
            let endDate=this.endDate==''||this.endDate==null?'':new Date(this.endDate+' 23:59:59').getTime().toString()
            let url = window.location.protocol + '//' + window.location.host
            url += `/api/v1/DeviceAlarm/export?companyId=${this.companyId}&keyword=${this.searchVal}&state=${this.alarmState==null?0:this.alarmState}&beginDate=${beginDate}&endDate=${endDate}&requestId=0`
            this.exportLogUrl = url
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(this.VerifyVal),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        // 下拉框title
        getTitle(val,data,code){
            if(val&&data&&code){
                let result=data.filter(ele => ele[code] == val);
                if (result.length!=0) return result[0].name
            }
        },
        mqttUpdate(){
          if(this.client){ }
            this.client.subscribe('sys/company/' + this.companyId + '/status/push', { qos: 1 }, (error) => {
                if(!error) {
                    // console.log('订阅设备属性主题成功')
                }else{
                    // console.log('订阅设备属性主题失败')
                }
            })
            // 接收消息处理
            this.client.on('message', (topic, message) => {
                // this.msg = message.toString()
                let url = 'sys/company/' + this.companyId + '/status/push'  //主题名
                if(topic == url){
                    this.search()
                }
            })
        }
    },
    watch: {
        client(){
            if(this.client&&this.mqttTrue){
                this.mqttUpdate()
                this.mqttTrue=false
            }
        }
    },
    beforeDestroy() {
        let options={
            onSuccess(){
                // console.log("退订成功")
            },
            onFailure(error){
                // console.log("退订失败")
            }
        }
        let url = 'sys/company/' + this.companyId + '/status/push'
        this.client.unsubscribe(url,options)
    },
}
</script>
<style scoped>
    .list-box{
        position: absolute;
        top: 98px;
        left: 16px;
        right: 16px;
        bottom: 0;
        min-width: 1360px;
    }
    /* 头部标签 */
    .tabs-box{
        position: absolute;
        top: -40px;
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    /* 背景盒子 */
    .bg{
        background-color: #fff;
        padding: 20px;
        /* margin-bottom: 20px; */
        /* margin-top: 20px; */
        /* min-height: 666px; */
    }
    /* 列表 */
    .scroll{
        overflow: auto;
        max-height: 630px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        line-height: 44px;
        font-size: 14px;
        position: relative;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 140px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-bottom:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .w-26{
        width: 26% !important;
    }

    .w-90{
      width: 90px !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
        margin-bottom: 18px;
    }
    /* .m-t-38{
        margin-top: 38px;
    }
    .top-20{
        position: absolute;
        top: 20px;
    } */
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 7%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-289px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 4px;
    }
    /* 报警 */
    .popup-addAlarm{
        width: 1200px !important;
        height: 702px !important;
        top: -98px !important;
        margin-left: -600px !important;
    }
    .alarm-left,.alarm-right{
        width: 530px;
        float: left;
    }
    .alarm-right{
        margin-left: 66px;
    }
    .w-100{
        margin:16px 0 0 0!important;
        width: 100% !important;
    }
    .trigger-box{
        /* height: 90px; */
        max-height: 148px;
        padding-bottom: 8px;
        overflow: auto;
        float: left;
        width: 100%;
        background: #f8f8f8;
        padding: 0 5px 0 10px;
        box-sizing: border-box;
        border: 1px solid #dcdcdc;
    }
    .condition-box{
        width: 100%;
    }
    .attribute{
        /* width: 117px; */
        margin-right: 6px;
    }
    .attribute.w-75{
        width: 95px;
    }
    .addAttrBtn{
        margin-top: 18px;
    }
    .checkbox-box{
        margin-top: 35px;
    }
    .delAttr{
        float: right;
        color: #5087e4;
        cursor: pointer;
    }
    .disabled2{
        color: #c3c3c3;
    }
    .bool p{
        padding:10px 0 0 10px;
    }
    .date{
        display: inline-block;
        width: 100%;
        background: #eee;
        text-align: left;
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 12px;
        color: #a4a4a4;
    }
    .text{
        position: absolute;
        right: 0;
        display: inline-block;
        width: 40px;
        text-align: center;
        border: 1px solid #dedede;
        line-height: 32px;
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .m-t-70{
        margin-top: 70px !important;
    }
    .b-128{
        position: absolute;
        bottom: 128px;
        left: 0;
    }
    .enum-title span{
        display: inline-block;
        width: 220px;
    }
    .enum-title>span:last-child{
        margin-left: 30px;
    }
    .add-enum{
        color: #5087e4;
        cursor: pointer;
        float: left;
    }
    .enum-box{
        margin-bottom: 10px;
    }
    .m-r-0{
        margin-right: 0 !important;
    }
    .note{
        height: 133px;
    }
    .m-t-20{
        margin-top: 20px;
    }
    .duration{
        padding-top: 20px;
    }
    input.w-415{
        width: 415px !important;
        margin: 0 8px;
        line-height: 16px;
        border: 1px solid #dedede;
        border-radius: 5px;
        padding: 8px;
        box-sizing: border-box;
    }
    .nodeType{
        margin-left: 10px;
    }
    .note{
        height: 133px;
    }
    .alarm-p{
        margin-top: 10px;
        margin-bottom: 6px;
        font-size: 14px;
    }
    .search-box{
        text-align: left;
        font-size: 15px;
    }
    .state-box{
        width: 120px;
        margin-right: 32px;
    }
    .time{
        margin-left: 12px;
        width: 180px;
        margin-right: 25px
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 75%;
        max-width: 388px;
        min-width: 160px;
        margin-right: 10px;
    }
    .w-25{
        width: 25%;
    }
    .w-20{
        width: 15%;
    }
    .m-r-12{
        margin-right: 12px;
    }
    .m-r-10{
        margin-right: 10px;
    }
    .m-t-0{
        margin-top: 0 !important;
    }
    li.red{
        color: #ff2323;
    }
    .disable-span{
        color: #a0cfff !important;
        cursor: not-allowed !important;
    }
</style>
<style>
    #devAlarm .el-radio{
        margin-right: 15px !important;
    }
    #devAlarm .enum .el-form-item__label,#devAlarm .bool .el-form-item__label,#devAlarm .range .el-form-item__label,#devAlarm .w-100 .el-form-item__label{
        width: 100%;
        text-align: left;
    }
    #devAlarm .range .el-input{
        width: 242px;
    }
    #devAlarm .enum .el-input{
        width: 210px;
    }
    #devAlarm .bool .el-input{
        width:482px;
        float: right;
    }
    #devAlarm .remarks textarea{
        width: 100% !important;
        height: 78px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box  !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
    #devAlarm .duration .el-input{
        width: 80% !important;
    }
    #devAlarm .remarks.note textarea{
        height: 133px !important;
    }
    #devAlarm .popup .el-input__inner,
    #devAlarm .state-box .el-input__inner,#devAlarm .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #devAlarm .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #devAlarm .popup .trigger-box .w-28.el-form-item{
        float: left;
        width: 24% !important;
        margin-bottom: 11px !important;
    }
    #devAlarm .popup .trigger-box .w-95.el-form-item {
        float: left;
        width: 95px !important;
        margin-right: 6px;
        margin-bottom: 11px !important;
    }
    #devAlarm .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #devAlarm .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #devAlarm .search .el-icon-search{
        line-height: 34px !important;
    }
    #devAlarm .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #devAlarm .attribute .el-input__icon,#devAlarm .state-box .el-input__icon{
        line-height: 34px !important;
    }
    .enum .el-form-item__error{
        padding-top: 0 !important;
    }
    #devAlarm .checkbox-box .el-checkbox{
        width: 27% !important;
    }
    #devAlarm .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
    #devAlarm .time .el-input__icon {
        position: relative;
        top: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CompanyConsole/DeviceAlarm/DeviceAlarmList.vue